/* eslint-disable import/no-unresolved */
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import { useMutation, useReactiveVar } from '@apollo/client';
import {
    Table, Checkbox, Button, TextArea,
} from 'appkit-react';

import { RUN_REMEDIATION_FOR_FRY7Q } from 'Apollo/Mutations/Rules/Fry7qResults';
import { tenantIdVar } from 'Apollo/config';

const ImpactedRules = ({
    data = {}, setShowImpactModal, updateRemediation, rowId,
}) => {
    const history = useHistory();
    const location = useLocation();
    const [batchId, setBatchId] = useState(location.state.batchId);
    const [ruleId, setRuleId] = useState(location.state.ruleId);
    const [regulation, setRegulation] = useState(location.state.regulation);
    const { validateRemediationForFRY7Q = [] } = data;
    const [checked, setChecked] = useState(false);
    const [showImpactCommentModal, setShowImpactCommentModal] = useState(false);
    const [comment, setComment] = useState('');
    const tenantId = useReactiveVar(tenantIdVar);

    /* Apollo mutation to delete a comment  */
    const [onUpdateBatchRow, { loading: rowUpdateLoading }] = useMutation(RUN_REMEDIATION_FOR_FRY7Q);

    const onCancelClick = () => {
        setShowImpactCommentModal(false);
        setShowImpactModal(false);
    };

    /* Save click handler and after calling onUpdateBatchRow() navigates back to
    result summary page */
    const onSaveClick = async () => {
        const input = {
            rowId: parseInt(rowId, 10),
            batchId: Number(batchId),
            ruleId: Number(ruleId),
            tenantId: parseInt(tenantId, 10),
        };
        let commentStr = `${comment},`;
        const filteredRemediation = updateRemediation.filter(remedi => remedi.modified);
        filteredRemediation.forEach((re, index) => {
            // eslint-disable-next-line no-bitwise
            commentStr = `${commentStr}mdrm:${re.mdrm} old_value:${Number(re.value) | 0
                // eslint-disable-next-line no-bitwise
                || re.value} new_value:${Number(re.newValue) | 0
                    || re.newValue}${index + 1 !== filteredRemediation.length
                ? ',' : ''}`;
            const key = re.mdrm;
            // eslint-disable-next-line no-nested-ternary
            const newInputValue = re.newValue ? Number(re.newValue) : null;
            input[key] = re.type === 'INTEGER' ? newInputValue : re.newValue;
        });
        input.comment = commentStr;
        await onUpdateBatchRow({
            variables: {
                input,
            },

        });
        setShowImpactCommentModal(false);
        setShowImpactModal(false);
        history.push(
            {
                pathname: '/fry7q',
                state: {
                    regulation,
                },
            },
        );
    };

    /* Column configuration for impacted rules table */
    const columns = [{
        Header: 'Rule ID',
        accessor: 'ruleId',
        minWidth: 35,
    },
    {
        Header: 'Schedule/Part',
        accessor: 'schedule',
        Cell: props => {
            const { original: { schedule, targetItem } } = props;
            return <span>{`${schedule}/ ${targetItem}`}</span>;
        },
        minWidth: 100,
    },
    {
        Header: 'MDRM Number',
        accessor: 'mdrmNumber',
        minWidth: 60,
    }, {
        Header: 'Rule Description',
        accessor: 'ruleDescription',
        minWidth: 120,
    }, {
        Header: 'Current Status',
        accessor: 'previousRunStatus',
        minWidth: 50,
    }, {
        Header: 'New Status',
        accessor: 'newRunStatus',
        minWidth: 50,
    }];

    /* Side effect when location state updates */
    useEffect(() => {
        setBatchId(location.state.batchId);
        setRuleId(location.state.ruleId);
        setRegulation(location.state.regulation);
    }, [location]);

    if (showImpactCommentModal) {
        return (
            <Modal
                show
                className="true-comply-impact-rules__comment-modal"
            >
                <div className="true-comply-impact-rules-modal-title">Comment*</div>
                <div className="secondary-input-container  a-apply-theme-background-gray-level-2 marginTop30">
                    <TextArea
                        placeholder="Comment is required."
                        textBoxSize="sm"
                        className="fix-textarea"
                        value={comment}
                        onChange={value => setComment(value)}
                    />
                </div>
                <div className="true-comply-impact-rules-modal__button-group">
                    <Button size="xl" kind="secondary" onClick={onCancelClick}>Cancel</Button>
                    <Button size="xl" disabled={!comment} onClick={onSaveClick} isLoading={rowUpdateLoading}>Save</Button>
                </div>
            </Modal>
        );
    }
    return (
        <Modal
            show
            className="true-comply-impact-rules-modal"
        >
            <div className="true-comply-impact-rules-modal-title">Impacted Rules</div>
            <Table
                data={validateRemediationForFRY7Q || []}
                columns={columns}
                showPagination={false}
                striped
                resizable
                noDataText="No Remediation ..!!!"
                className="true-comply-impact-rules-modal-table marginTop30"
            />
            {(validateRemediationForFRY7Q && validateRemediationForFRY7Q.length > 0) && (
                <div className="marginTop30">
                    <Checkbox
                        checked={checked}
                        onChange={e => setChecked(e.target.checked)}
                    >
                        Once you click on confirm,that updated value will be saved and will impact the rules listed above.
                    </Checkbox>
                </div>
            )}
            <div className="true-comply-impact-rules-modal__button-group">
                <Button size="xl" kind="secondary" onClick={() => setShowImpactModal(false)}>Cancel</Button>
                <Button size="xl" disabled={!checked} onClick={() => setShowImpactCommentModal(true)}>Confirm</Button>
            </div>
        </Modal>
    );
};

export default ImpactedRules;
